export default "__VITE_ASSET__CWOEFjSd__"